import React, { useState, useEffect } from "react";
import sendCustomEmail from "../../functions/sendCustomEmail";
import BotonManualHeader from "../../components/BotonManualHeader";
import Swal from "sweetalert2";
import firebaseApp from "../../firebase/credenciales";
import { Container, Table, Spinner, Card, Form, Row, Col, Button } from "react-bootstrap";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa"; // Importa los iconos que necesitas
import {
  collection,
  getFirestore,
  getDocs,
  query,
  where,
  doc,
  getDoc,
} from "firebase/firestore";

const db = getFirestore(firebaseApp);

const CorreoMasivos = ({ usuario }) => {
  const [emails, setEmails] = useState([]);
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [cc, setCc] = useState("miboleta@perubi.com");
  const [bcc, setBcc] = useState("");
  const [colecion, setColecion] = useState("mailTurbo");
  const [sentEmails, setSentEmails] = useState([]); // Declaración de useState
  const [failedEmails, setFailedEmails] = useState([]);
  // Combina los correos enviados y fallidos en un solo array
  const allEmails = [...sentEmails, ...failedEmails];
  const [rucEmpresa, setRucEmpresa] = useState(usuario.ruc); // Añade un estado para el rucEmpresa
  const [isLoading, setIsLoading] = useState(false);
  const [mostrarEncabezado, setMostrarEncabezado] = useState(false);
  const [botonDesactivado, setBotonDesactivado] = useState(false);
  const [name, setName] = useState("");
  const [apellidos, setApellidos] = useState("");
  const [previewClicked, setPreviewClicked] = useState(false);

  console.log(usuario);

  // Definir el estado para el mes y la semana
  const [mesN, setMesN] = useState("");
  const [semN, setSemN] = useState("");
  const [anoN, setAnoN] = useState(new Date().getFullYear().toString());
  const [periodo, setPeriodo] = useState("");
  const [td, setTd] = useState("");
  const [empresa, setEmpresa] = useState("");
  let semana = semN ? `  SEM${semN}` : "";

  useEffect(() => {
    const fetchNombreEmpresa = async () => {
      if (usuario?.empresa) {
        setEmpresa(usuario.empresa);
        return;
      }
      const rucCurrent = rucEmpresa || usuario?.ruc || usuario?.rucEmpresa;
      if (rucCurrent) {
        try {
          const docRef = doc(db, "company", rucCurrent);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            const data = docSnap.data();
            setEmpresa(data.name || data.razonSocial || data.nombreComercial || data.empresa || rucCurrent);
          } else {
            setEmpresa(rucCurrent);
          }
        } catch (err) {
          console.error("Error al consultar datos de empresa:", err);
        }
      }
    };
    fetchNombreEmpresa();
  }, [rucEmpresa, usuario?.ruc, usuario?.empresa]);

  // Definir el estado para la vista previa
  const [preview, setPreview] = useState(false);

  const handlePreview = () => {
    // Crear el asunto y cuerpo del correo para la vista previa
    const previewSubject = `${empresa.toUpperCase()} - ${td.toUpperCase()} - ${mesN}/${anoN}${semana}`;
    const previewBody = `<p><b>Estimado(a) USUARIO DE PRUEBA</b></p>
      <p>Te hacemos entrega de tus <b>${td.toUpperCase()}</b> correspondiente al periodo <b>${mesN}/${anoN}${semana}</b>, conforme a lo establecido por el Decreto Supremo N° 001-98-TR, D.S. N° 009-2011-TR y Decreto Legislativo N° 1310.</p>
      <p>Para visualizarla, haz clic al siguiente enlace, coloca tu Email y como password tu número de DNI.</p> 
      <p><a href="https://miboleta.net.pe/app/"><b>Haz clic aquí</b></a></p>
      
      <p><b>RECOMENDACIONES: </b></p>
      <p>• Para acceder a la plataforma <b>Mi Boleta</b> a través de la Web, usa tu navegador favorito. </p>
      <p>• Para visualizar sus documentos a través del Aplicativo móvil instale en su dispositivo Mi Boleta APP desde
        Google Play <a href="https://play.google.com/store/apps/details?id=pe.perubi.miboleta"><b>Mi Boleta APP</b></a>, actualiza a la ultima versión para visualizar correctamente tus boletas.</p>
      <p>• Los usuarios de IPHONE pueden visualizar sus documentos directamente desde este enlace <a href="
      https://miboleta.net.pe/app/">https://miboleta.net.pe/app</a></p>
  
      <p>Atentamente,</p>
      <p><b>${empresa.toUpperCase()}</b></p>
      <p>*Esta cuenta de correo electrónico solo es utilizada para enviar esta notificación; te agradeceremos no responder con consultas personales. Si tienes alguna duda, por favor comunícate con el Área de Recursos Humanos.</p>
      <p>**Si no puedes visualizar el correo correctamente, por favor, verifica que no se encuentre en la carpeta de SPAM.</p>
      <p>***Si no deseas recibir más correos de este tipo, por favor, comunícate con el Área de Recursos Humanos.</p>`;

    // Actualizar los estados
    setSubject(previewSubject);
    setBody(previewBody);
    setPreview(!preview);
    setPreviewClicked(true);
  };

  const handlePeriodoChange = (e) => {
    const value = e.target.value;
    setPeriodo(value);
    if (value === "mensual") {
      setSemN("");
    }
  };

  useEffect(() => {
    const fetchEmails = async () => {
      const userCollection = collection(db, "users");
      const q = query(userCollection, where("rucEmpresa", "==", rucEmpresa));
      const userSnapshot = await getDocs(q);
      const userList = userSnapshot.docs.map((doc) => {
        const data = doc.data();
        const nombre = data.name;
        const apellidos = data.apellidos;
        const email = data.email;
        const subject = `${empresa.toUpperCase()} - ${td.toUpperCase()} - ${mesN}/${anoN}${semana}`;


        // Definir el cuerpo del correo aquí
        let body = `<p><b>Estimado(a) ${data.name} ${data.apellidos} </b></p>
          <p>Te hacemos entrega de tus <b>${td.toUpperCase()}</b> correspondiente al periodo <b>${mesN}/${anoN}${semana}</b>, conforme a lo establecido por el Decreto Supremo N° 001-98-TR, D.S. N° 009-2011-TR y Decreto Legislativo N° 1310.</p>
          <p>Para visualizarla, haz clic al siguiente enlace, coloca tu Email y como password tu número de DNI.</p> 
          <p><a href="https://miboleta.net.pe/app/"><b>Haz clic aquí</b></a></p>
          
          <p><b>RECOMENDACIONES: </b></p>
          <p>• Para acceder a la plataforma <b>Mi Boleta</b> a través de la Web, usa tu navegador favorito. </p>
          <p>• Para visualizar sus documentos a través del Aplicativo móvil instale en su dispositivo Mi Boleta APP desde
            Google Play <a href="https://play.google.com/store/apps/details?id=pe.perubi.miboleta"><b>Mi Boleta APP</b></a>, actualiza a la ultima versión para visualizar correctamente tus boletas.</p>
          <p>• Los usuarios de IPHONE pueden visualizar sus documentos directamente desde este enlace <a href="
          https://miboleta.net.pe/app/">https://miboleta.net.pe/app</a></p>
    
          <p>Atentamente,</p>
          <p><b>${empresa.toUpperCase()}</b></p>
          <p>*Esta cuenta de correo electrónico solo es utilizada para enviar esta notificación; te agradeceremos no responder con consultas personales. Si tienes alguna duda, por favor comunícate con el Área de Recursos Humanos.</p>
          <p>**Si no puedes visualizar el correo correctamente, por favor, verifica que no se encuentre en la carpeta de SPAM.</p>
          <p>***Si no deseas recibir más correos de este tipo, por favor, comunícate con el Área de Recursos Humanos.</p>`;

        setBody(body); // Actualizar el estado con el cuerpo del correo

        return {
          email: email,
          nombre: nombre,
          apellidos: apellidos,
          subject: subject,
          body: body,
        };
      });
      setEmails(userList);
    };

    fetchEmails();
  }, [rucEmpresa, mesN, semN, anoN, td, empresa, email]);

  // Modificar la función sendEmails
  const sendEmails = () => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: `¿Estás seguro el correo se enviara con este asunto ${empresa.toUpperCase()} - ${td.toUpperCase()} - ${mesN}/${anoN}${semana} a todos los trabajadores?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, enviar!",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);
        setPreview(false);

        Promise.all(
          emails.map((email) =>
            sendCustomEmail(email.email, cc, bcc, email.subject, email.body, colecion)
              .then(result => {
                // Verificamos si el resultado existe y tiene id
                return {
                  nombre: email.nombre,
                  apellidos: email.apellidos,
                  email: email.email,
                  sent: !!(result && result.id)
                };
              })
              .catch(error => {
                console.error('Error enviando email:', error);
                return {
                  nombre: email.nombre,
                  apellidos: email.apellidos,
                  email: email.email,
                  sent: false
                };
              })
          )
        ).then((results) => {
          const sent = results.filter(result => result.sent);
          const failed = results.filter(result => !result.sent);

          setSentEmails(sent);
          setFailedEmails(failed);
          setIsLoading(false);

          // Mostrar mensaje de resultado
          Swal.fire({
            title: 'Envío completado',
            text: `Se enviaron ${sent.length} correos exitosamente y ${failed.length} fallaron`,
            icon: sent.length > 0 ? 'success' : 'error'
          });
        });
      }
    });
    setMostrarEncabezado(true);
    setBotonDesactivado(true);
  };

  return (
    <Container className="my-5">
      {isLoading ? (
        <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-75" style={{zIndex: 1080}}>
          <div className="text-center">
            <Spinner animation="border" variant="light" style={{width: "3rem", height: "3rem"}}/>
            <p className="text-white mt-3 mb-0">Procesando correos...</p>
          </div>
        </div>
      ) : (
        <Card className="shadow border-0">
          <Card.Header className="text-white py-4 position-relative" style={{ background: "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)", borderBottom: "3px solid #f39c12" }}>
            <div className="position-absolute end-0 top-50 translate-middle-y me-4" style={{ zIndex: 10 }}>
              <BotonManualHeader usuario={usuario} />
            </div>
            <div className="text-center">
              <h2 className="fw-bold mb-1">Envío de Correos Masivos</h2>
              <p className="mb-0 opacity-75">Envía notificaciones y documentos por correo electrónico a tus trabajadores</p>
            </div>
          </Card.Header>
  
          <Card.Body className="p-4">
            {/* Selector de tipo de documento */}
            <div className="bg-light p-4 rounded-3 shadow-sm mb-4">
              <Form.Group>
                <Form.Label className="fw-bold">Tipo de Documento</Form.Label>
                <Form.Select 
                  value={td}
                  onChange={(e) => setTd(e.target.value)}
                  className="form-control-lg"
                >
                  <option value="">Seleccione tipo de documento</option>
                  <option value="Boletas de pago">BOLETAS DE PAGO</option>
                  {/* ...resto de opciones... */}
                </Form.Select>
              </Form.Group>
            </div>
  
            {/* Selector de frecuencia */}
            {td && (
              <div className="bg-light p-4 rounded-3 shadow-sm mb-4">
                <Form.Group>
                  <Form.Label className="fw-bold">Frecuencia del Documento</Form.Label>
                  <Form.Select
                    value={periodo}
                    onChange={handlePeriodoChange}
                    className="form-control-lg"
                  >
                    <option value="">Seleccione la frecuencia</option>
                    <option value="mensual">MENSUAL</option>
                    <option value="semanal">SEMANAL</option>
                  </Form.Select>
                </Form.Group>
              </div>
            )}
  
            {/* Selectores de fecha */}
            {periodo && (
              <div className="bg-light p-4 rounded-3 shadow-sm mb-4">
                <Row className="g-3">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-bold">Mes</Form.Label>
                      <Form.Select
                        value={mesN}
                        onChange={(e) => setMesN(e.target.value)}
                        className="form-control-lg"
                      >
                        {/* ...opciones de mes... */}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-bold">Año</Form.Label>
                      <Form.Select
                        value={anoN}
                        onChange={(e) => setAnoN(e.target.value)}
                        className="form-control-lg"
                      >
                        {/* ...opciones de año... */}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  {periodo === "semanal" && (
                    <Col md={12}>
                      <Form.Group>
                        <Form.Label className="fw-bold">Semana</Form.Label>
                        <Form.Select
                          value={semN}
                          onChange={(e) => setSemN(e.target.value)}
                          className="form-control-lg"
                        >
                          {/* ...opciones de semana... */}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  )}
                </Row>
              </div>
            )}
  
            {/* Botones de acción */}
            <div className="d-flex gap-3 justify-content-end mt-4">
              <Button
                variant="secondary"
                size="lg"
                disabled={!td || !mesN || (periodo === "semanal" && !semN)}
                onClick={handlePreview}
              >
                Vista previa
              </Button>
              {previewClicked && (
                <Button
                  variant="primary"
                  size="lg"
                  onClick={sendEmails}
                  disabled={botonDesactivado}
                >
                  Enviar correos
                </Button>
              )}
            </div>
  
            {/* Vista previa */}
            {preview && (
              <Card className="mt-4 shadow-sm">
                <Card.Header className="bg-light">
                  <h5 className="mb-0">Vista Previa</h5>
                </Card.Header>
                <Card.Body>
                  <h6 className="fw-bold">Asunto: {subject}</h6>
                  <div dangerouslySetInnerHTML={{ __html: body }} />
                </Card.Body>
              </Card>
            )}
  
            {/* Tabla de resultados */}
            {mostrarEncabezado && (
              <Card className="mt-4 shadow-sm">
                <Card.Header className="bg-light">
                  <h5 className="mb-0">Resultados del Envío</h5>
                </Card.Header>
                <Card.Body className="p-0">
                  <Table responsive hover className="mb-0">
                    <thead className="bg-light">
                      <tr>
                        <th className="border-0">#</th>
                        <th className="border-0">Nombre</th>
                        <th className="border-0">Apellido</th>
                        <th className="border-0">Correo</th>
                        <th className="border-0">Estado</th>
                      </tr>
                    </thead>
                    <tbody>
                      {allEmails.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.nombre}</td>
                          <td>{item.apellidos}</td>
                          <td>{item.email}</td>
                          <td>
                            {item.sent ? (
                              <FaCheckCircle className="text-success" />
                            ) : (
                              <FaTimesCircle className="text-danger" />
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            )}
          </Card.Body>
        </Card>
      )}
    </Container>
  );
}

export default CorreoMasivos;